import { LOCATION_INITIALIZED } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, Injector, importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { RouterModule, Routes, provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
//import { SocketIoModule } from 'ngx-socket-io';
import { MessageService } from 'primeng/api';

import { HttpRequestsInterceptor } from '@pragma/interceptors';
import { NgxEchartsModule } from 'ngx-echarts';
import { environment } from '../environments/environment';
//import { MeasurementSocket } from './core/services/sockets/measurement-socket';
//import { WeatherMeasurementSocket } from './core/services/sockets/weather-measurement-socket';
import { pubSubFactory } from './core/services/azure/pub-sub.service';

export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient, 'assets/i18n/');
}

export function appInitializerFactory(translate: TranslateService, injector: Injector) {
    return () =>
        new Promise<any>((resolve: any) => {
            const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
            locationInitialized.then(() => {
                const supportedLangs = ['en', 'el'];
                const langToSet = localStorage.getItem('preferredLang') || 'en';

                translate.addLangs(supportedLangs);
                translate.setDefaultLang('en');
                translate.use(langToSet).subscribe({
                    next: () => {
                        console.log(`Successfully initialized '${langToSet}' language.'`);
                    },
                    error: () => {
                        console.error(`Problem with '${langToSet}' language initialization.'`);
                    },
                    complete: () => resolve(null)
                });
            });
        });
}

const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routes').then((m) => m.AuthRoutes)
    },
    {
        path: 'pages',
        loadChildren: () => import('./pages/pages.routes').then((m) => m.PagesRoutes)
    },
    {
        path: '',
        redirectTo: 'pages/admin/users',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: 'pages'
    }
];

export const appConfig = {
    providers: [
        provideRouter(routes, withEnabledBlockingInitialNavigation()),
        provideAnimations(),
        //MeasurementSocket,
        //WeatherMeasurementSocket,
        provideHttpClient(withInterceptorsFromDi()),
        importProvidersFrom(
            //SocketIoModule,
            RouterModule.forRoot(routes),
            NgxEchartsModule.forRoot({
                echarts: () => import('echarts')
            }),
            BrowserAnimationsModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient]
                }
            }),
            ServiceWorkerModule.register('/ngsw-worker.js', {
                enabled: environment.production
            })
        ),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpRequestsInterceptor,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFactory,
            deps: [TranslateService, Injector],
            multi: true
        },
        {
            provide: 'AZURE_SERVICE_PUB_SUB_CLIENT',
            useFactory: pubSubFactory,
            deps: [HttpClient]
        },
        MessageService
    ]
};
